import dayjs from 'dayjs'
import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import OrganismTableCompare from '~/components/organisms/table-compare/table-compare.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const camelCase = (str) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
}

const formatDate = (comparisons, date) => {
  return `${comparisons.pageComparison.lastUpdate} ${dayjs(date).format(
    'MMMM D, YYYY',
  )}`
}

const sortCompaniesByUpdateDate = (companies, orderBy) => {
  switch (orderBy) {
    case 'DESC':
      return companies.sort(
        (a, b) => new Date(b._updatedAt) - new Date(a._updatedAt),
      )
    case 'ASC':
      return companies.sort(
        (a, b) => new Date(a._updatedAt) - new Date(b._updatedAt),
      )
    default:
      return companies
  }
}

const Functional = (props) => {
  const companies = [
    props.record?.firstSoftwareCompare,
    props.record?.secondSoftwareCompare,
  ]
  const recentCompany = sortCompaniesByUpdateDate(companies, 'DESC')
  const recentHumanReadableDate = formatDate(
    props.comparisons,
    recentCompany._updatedAt,
  )
  const olderCompany = sortCompaniesByUpdateDate(companies, 'ASC')
  const oldHumanReadableDate = formatDate(
    props.comparisons,
    olderCompany._updatedAt,
  )

  return h(UiComponentWrapper, { class: 'comparisons' }, () => [
    h(UiComponentWrapper, { class: 'comparisons-table' }, () => [
      h(
        UiComponentWrapper,
        {
          class: 'header-fixed',
        },
        () => [
          h(UiComponentContainer, {}, () => [
            h(UiComponentWrapper, {}, () => [
              h(UiComponentParagraph, {}, () => [
                props.activeCategory,
              ]),
            ]),
            h(UiComponentWrapper, { class: 'livestorm' }, () => [
              h('img', {
                domProps: {
                  alt: 'Livestorm logo',
                  height: '24',
                  loading: 'lazy',
                  src: 'https://d33wubrfki0l68.cloudfront.net/0352c0a4ef30665c3a91958b667b9cc9ca96e7b3/f8e63/_nuxt/f98cdf953d49a4d117a307dfae190c51.svg',
                  width: '142.75',
                },
              }),
            ]),
            h(UiComponentWrapper, {}, () => [
              h(
                UiComponentParagraph,
                {
                  style: {
                    color: props.record?.secondSoftwareCompare.companyColor.hex,
                  },
                },
                () => [props.record?.secondSoftwareCompare.companyName],
              ),
            ]),
          ]),
        ],
      ),
      h(UiComponentWrapper, { class: 'table' }, () => [
        h(OrganismTableCompare, {
          features: props.comparisons.allFeaturesComparisons.map(
            feature => ({
              ...feature,
              key: camelCase(feature.slug),
            }),
          ),
          featuresCategories: props.comparisons.allFeaturesCategories,
          firstSoftware: props.record?.firstSoftwareCompare,
          isLivestorm: true,
          ratingDate: oldHumanReadableDate,
          secondSoftware: props.record?.secondSoftwareCompare,
        }),
      ]),
    ]),
    h(
      UiComponentContainer,
      {
        class: 'last-update',
        end: 1,
        start: 1,
      },
      () => [
        h(
          UiComponentParagraph,
          {
            size: 's',
          },
          () => [recentHumanReadableDate],
        ),
        h(
          AtomButton,
          {
            type: 'text',
            to: `mailto:${props.comparisons.pageComparison.askToEditMailTo}`,
          },
          () => [props.comparisons.pageComparison.askToEdit],
        ),
      ],
    ),
  ])
}

Functional.props = {
  activeCategory: {
    required: true,
    type: String,
  },
  comparisons: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
